<template>
  <div>
    <!-- 提出赔款 -->
    <el-dialog :title="$t('message.billOfIndemnity') + ':' + reparation_sn" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1800px" center>
      <div class="content">
        <div class="table">
          <ol>
            <!--  番号-->
            <li class="flex05">{{ $t("message.mash") }}</li>
            <!--  图片-->
            <li>{{ $t("message.pic") }}</li>
            <!--  商品属性-->
            <li>{{ $t("message.commodityAttribute") }}</li>
            <!--  附加服务-->
            <li>{{ $t("message.additionalServices") }}</li>
            <!--  商品数-->
            <li>{{ $t("message.numberOfGoods") }}</li>
            <!--  单价（元）-->
            <li class="flex05">{{ $t("message.priceYuan") }}</li>
            <!-- 客户反馈问题诉求（日语）-->
            <li class="flex15">
              {{ $t("message.customerFeedbackProblemRequestJP") }}
            </li>
            <!--业务售后处理意见（日语）-->
            <li class="flex15">
              {{ $t("message.adviceOnAfterSaleHandlingOfBusinessJP") }}
            </li>
            <!-- 产生问题原因-->
            <li class="flex15">{{ $t("message.causeOfTheProblem") }}</li>
            <!--赔款数量）-->
            <li>{{ $t("message.amountOfIndemnity") }}</li>
            <!--商品代赔款-->
            <li>{{ $t("message.indemnitiesForGoods") }}</li>
            <!--国内运费返还-->
            <li>{{ $t("message.returnOfDomesticFreight") }}</li>
            <!--手续费赔款-->
            <li>{{ $t("message.commissionIndemnity") }}</li>
            <!--option赔款-->
            <li>{{ $t("message.optionForCompensation") }}</li>
            <!--合计-->
            <li>{{ $t("message.total") }}</li>


            <!--预计承担金额.-->
            <li>{{ $t("message.estimatedLiability") }}元</li>
          </ol>
          <!-- 列表详情 -->
          <div class="table_detail" v-for="(item, index) in indemnityList" :key="index">
            <!-- 订单号分单-->
            <div class="detail_head">
              <!-- 订单 -->
              <div class="order">
                <div>
                  <p>{{ item.order_sn }}</p>
                  <p>{{ item.user ? item.user.realname : '' }}</p>
                </div>
              </div>
              <!-- 订单汇率 -->
              <div class="item">
                {{ $t("message.orderRate") }}:{{ item.exchange_rate }}円/元
              </div>
              <div class="item">
                {{ $t("message.business") }}:{{ item.y_admin ? item.y_admin.realname : '' }}
              </div>
              <!-- 采购 -->
              <div class="item">
                {{ $t("message.purchase") }}: {{ item.g_admin ? item.g_admin.realname : '' }}
              </div>
              <!-- 配货 -->
              <div class="item">
                {{ $t("message.distribution") }}:{{ item.p_admin ? item.p_admin.realname : '' }}
              </div>
            </div>
            <!-- 列表 -->
            <ul v-for="(items, indexs) in item.list" :key="indexs">
              <!--  番号-->
              <li class="flex05">{{ items.sorting }}</li>
              <!--  图片-->
              <li>
                <el-popover placement="right" width="300" trigger="hover">
                  <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                  <a :href="`https://detail.1688.com/offer/${items.goods_id}.html`" target="_blank" slot="reference">
                    <img :src="items.pic" alt="" style="width: 60px; height: 60px" />
                  </a>
                </el-popover>
              </li>
              <!--  商品属性-->
              <li>
                <div class="attribute">
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(itemDetail, itemIndex) in items.detail_y" :key="itemIndex"
                        style="margin-bottom: 5px">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                    <div>
                      <div class="row" v-for="(itemDetail, itemIndex) in items.detail_y" :key="itemIndex">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!--  附加服务-->
              <li>
                <div class="attribute">
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(opti, optiIndex) in items.option" :key="optiIndex"
                        style="margin-bottom: 3px">
                        <p v-if="opti.num > 0">
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price
                          }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                    <div style="height: 80px">
                      <div class="row" v-for="(opti, optiIndex) in items.option" :key="optiIndex">
                        <p v-if="opti.num > 0">
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price
                          }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!--  商品数-->
              <li>
                <div class="attribute">
                  <!-- 购买数 -->
                  <p>
                    {{ $t("message.purchaseNumber") }}:{{ items.confirm_num }}
                  </p>
                  <!-- 发送数 -->
                  <p>
                    {{ $t("message.numberOfTransmissions") }}:{{ items.fasong_num }}
                  </p>
                </div>
              </li>
              <!--  单价（元）-->
              <li class="flex05">{{ items.confirm_price }}</li>
              <!-- 客户反馈问题诉求（日语）-->
              <li class="flex15">
                {{ items.client_desc }}
              </li>
              <!--业务售后处理意见（日语）-->
              <li class="flex15">
                {{ items.admin_desc }}
              </li>
              <!-- 产生问题原因（内部） -->
              <li class="flex15">
                {{ items.internal_reason }}
              </li>
              <!--赔款数量）-->
              <li>
                {{ items.num }}
              </li>
              <!--商品代赔款-->
              <li>
                <div class="attribute">
                  <p>{{ amountRefundName(items.amount_goods_type) }}</p>
                  <p>赔付：{{ items.amount_goods_amount }}</p>
                </div>
              </li>
              <!--国内运费返还-->
              <li>
                <div class="attribute">
                  <p>{{ amountRefundName(items.amount_freight_type) }}</p>
                  <p>赔付：{{ items.amount_freight_amount }}</p>
                </div>
              </li>
              <!--手续费赔款-->
              <li>
                <div class="attribute">
                  <p>{{ amountRefundName(items.amount_service_type) }}</p>
                  <p>赔付：{{ items.amount_service_amount }}</p>
                </div>
              </li>
              <!--option赔款-->
              <li>
                <div class="attribute">
                  <p v-for="(opti, optiIndex) in items.amount_option_detail" :key="optiIndex"></p>
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(opti, optiIndex) in items.amount_option_detail" :key="optiIndex"
                        style="margin-bottom: 3px">
                        <p v-if="opti.refund_num > 0">
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.refund_num }} * {{ opti.price
                          }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                    <div style="height: 80px">
                      <div class="row" v-for="(opti, optiIndex) in items.amount_option_detail" :key="optiIndex">
                        <p v-if="opti.refund_num > 0">
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.refund_num }}*{{ opti.price
                          }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!--合计-->
              <li>
                <div>
                  <p>{{ items.total }}.円</p>
                  <p>{{ (items.total / item.exchange_rate).toFixed(2) }}元</p>
                </div>
              </li>
              <!--预计承担金额.-->
              <li>{{ (items.total / item.exchange_rate * items.rate / 100).toFixed(2) }}元</li>
            </ul>
          </div>
        </div>
        <!-- add -->
        <div class="add">
          <el-button type="success" size="mini" @click="add" v-if="isAuth(346)">{{ $t('message.add') }}</el-button>
        </div>
        <!-- 赔款人 -->
        <div class="indemnity_details">
          <!-- 主责任人 -->
          <div class="responsible_box">
            <div class="responsible_person">


              <!-- 赔款类别 -->
              <div class="row">
                <div class="label">
                  {{ $t('message.compensationCategory') }}:
                </div>
                <div class="val">
                  <el-select filterable v-model="reparation_reason" size="mini" placeholder="请选择">
                    <el-option v-for="item in reparationReasonList" :label="item" :value="item" :key="item">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!-- 赔款数量:： -->
              <div class="row">
                <div class="label">
                  {{ $t('message.amountOfIndemnity') }}:
                </div>
                <div class="val"><el-input v-model="reparation_num" size="mini" @blur="getReparationsByUser"></el-input>
                </div>
              </div>
              <!-- 赔款类型:： -->
              <div class="row">
                <div class="label">
                  {{ $t('message.reparationType') }}:
                </div>
                <div class="val">
                  <el-select filterable v-model="reparation_type" size="mini" @change="getReparationsByUser"
                    placeholder="请选择">
                    <el-option v-for="item in reparationType" :label="item.value" :value="item.value" :key="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!-- 责任人类别： -->
              <div class="row">
                <div class="label">
                  {{ $t('message.categoryOfResponsiblePerson') }}:
                </div>
                <div class="val">
                  <!-- 公司员工 -->
                  <div class="item">
                    <div class=" radio">
                      <el-radio v-model="liable_type" label="1" @change="changeRadio">
                        {{ $t('message.companyEmployee') }}
                      </el-radio>
                    </div>
                    <div class="input">
                      <el-select v-model="liable_content" placeholder="请选择" size="small" @change="changeAdmin"
                        filterable>
                        <el-option v-for="item in adminList" :key="item.id" :label="item.realname" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <!-- 外部物流公司 -->
                  <div class="item">
                    <div class=" radio">
                      <el-radio v-model="liable_type" label="2" @change="changeRadio">
                        {{ $t('message.externalLogisticsCompany') }}
                      </el-radio>
                    </div>
                    <div class="input">
                      <el-select filterable v-model="wuliuName" placeholder="物流公司" size="mini"
                        @change="otherResponsibility">
                        <el-option v-for="item in logisticsList" :label="item.name" :value="item.name" :key="item.id">
                        </el-option>
                      </el-select>
                      <!-- <el-input v-model="wuliuName" size="small" @input="otherResponsibility"></el-input> -->
                    </div>
                  </div>
                  <!-- 第三方卖家 -->
                  <div class="item">
                    <div class=" radio">
                      <el-radio v-model="liable_type" label="3" @change="changeRadio">
                        {{ $t('message.thirdPartySeller') }}
                      </el-radio>
                    </div>
                    <div class="input">
                      <el-input v-model="thirdParty" size="small" @input="otherResponsibility"
                        placeholder="请输入店铺名"></el-input>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 责任人所在组织:： -->
              <div class="row">
                <div class="label">
                  {{ $t('message.theOrganizationOfThePersonResponsible') }}:
                </div>
                <div class="val">{{ liable_organization }}</div>
              </div>
              <!-- 具体赔款原因 -->
              <div class="row">
                <div class="label">
                  {{ $t('message.reasonForCompensation') }}:
                </div>
                <div class="val">
                  <el-input type="textarea" v-model="reason">
                  </el-input>
                </div>
              </div>
            </div>
          </div>
          <!-- 赔款明细 -->
          <div class="expenses_details">

            <div class="total">
              <div class="item"> 理应赔款金额：<el-input v-model="should_amount"></el-input> 元</div>
              <div class="item">
                实际赔款金额：<el-input v-model="actual_amount"></el-input>元
              </div>
              <div class="item">团队赔款：<el-input v-model="team_amount" type="number" min="0"
                  step="0.01" @input="teamAmountEdited = true"></el-input>元</div>
            </div>
            <div class="table">
              <ol>
                <!-- 赔款明细 -->
                <li>{{ $t('message.compensationDetails') }}</li>
                <!-- 责任人选择 -->
                <li>{{ $t('message.responsiblePersonSelection') }}</li>
                <!-- 责任人角色 -->
                <li>{{ $t('message.responsiblePersonRole') }}</li>
                <!--费用承担 -->
                <li>费用承担</li>
                <!-- 操作 -->
                <li class="flex05">{{ $t('message.operation') }}</li>
              </ol>
              <!-- 关联责任人 -->
              <ul v-for="(item, index) in reparationList" :key="index">
                <!-- 赔款明细 -->
                <li>
                  <span v-if="item.type == 2">
                    {{ $t('message.associatedResponsiblePerson') }} {{ index + 1 }}
                  </span>
                  <span v-else> 主责任人</span>
                </li>
                <!-- 责任承担人 -->
                <li>
                  <span v-if="item.type == 3 || item.main == '公司'">
                    {{ item.main }}
                  </span>
                  <el-select v-model="item.main" placeholder="请选择" size="small" @change="changeName($event, index)"
                    filterable v-else>
                    <el-option v-for="item in adminList" :key="item.id" :label="item.realname" :value="item.id">
                    </el-option>
                  </el-select>
                </li>
                <!-- 责任人角色 -->
                <li>{{ item.name }}</li>
                <!--费用承担 -->
                <li>
                  <el-input v-model="item.amount" type="number" onfocus="this.select()"
                    @input="actual_amount_total"></el-input>
                </li>
                <!-- 操作 -->
                <li class="flex05">
                  <el-button type="danger" class="dark" size="mini" @click="del(index)" v-if="item.type == 2">
                    {{ $t('message.delete') }}
                  </el-button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 赔款单-添加 -->
        <el-button type="primary" @click="storeReparation" v-if="isAuth(346)">
          {{ $t("message.billOfIndemnityAdded") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

import { mapState } from 'vuex'
import { reparationType } from '@/utlis/options'
export default {
  props: {
    indemnityList: { type: Array },
    amountRefundType: { type: Array },
    adminList: { type: Array },

  },
  data() {
    return {
      reparationType,
      dialogVisible: false,
      detail: {}, //详情
      reason: '',// 赔款原因
      reparation_sn: '',//赔款单号
      options: [],//责任人选择
      liable_type: '', //责任人类别
      liable_content: '',//责任主体内容
      liable_name: '', //责任人名称
      liable_organization: '', //责任人所在组织:
      wuliuName: '', //物流填写
      thirdParty: '',//第三方卖家
      reparation_type: '',//赔款类别
      reparation_num: '',//赔款数量
      reparationList: [], //关联责任人
      responsiblePersonData: {
        type: '1',
        main: '',
        rate: 0,
        amount: 0,
        name: '',
        should_amount: 0,
      },
      total: 0,//合计
      actual_amount: 0,//理应赔款
      should_amount: 0,//全部实际赔款
      team_amount: 0,//团队赔款
      teamAmountEdited: false,//人工修改后不再跟随理应赔款
      reparationReasonList: [],//赔款类别选项
      reparation_reason: '',//赔款类别
    };
  },
  computed: {
    ...mapState({
      logisticsList: (state) => state.porderDetail.logisticsList,

    }),
  },
  methods: {
    // 获取赔款类型选项
    reparationReason(liable_content = '') {
      this.reparation_reason = ''
      this.$api.capitalApi
        .reparationReason({ liable_content }).then(res => {
          this.reparationReasonList = Array.isArray(res.data) ? res.data : []
          this.$forceUpdate()
        })
    },
    validateReparationReason() {
      if (this.reparationReasonList.length && !this.reparation_reason) {
        this.$message.error('赔款类别未选择')
        return false
      }
      return true
    },
    // 根据理应赔款计算金额
    getReparationsByUser() {
      let datas = {
        userName: this.responsiblePersonData.name,
        shouleMoney: this.should_amount,
        type: this.reparation_type,
        numbers: this.reparation_num
      }
      if (datas.userName == '' || datas.type == '' || datas.numbers === '') {
        return false
      }
      this.reparationList = []
      this.$api.capitalApi.getReparationsByUser(datas).then((res) => {
        if (res.errcode == 1) return false

        res.data.peikuan.forEach(item => {
          if (item.name == '公司') {
            this.reparationList.push({
              main: item.name,
              rate: 1,
              amount: item.amount,
              type: '2',
              name: item.name,
              should_amount: 0,
            })
          } else {
            let nameData = this.adminList.find(items => items.realname == item.name)
            this.reparationList.push({
              main: nameData.id,
              rate: 1,
              amount: item.amount,
              type: nameData.realname == datas.userName ? '1' : '2',
              name: nameData.role[0].name,
              should_amount: nameData.realname == datas.userName ? this.actual_amount : 0,
            })
          }

        })
        this.actual_amount_total()


      })
    },
    // 售后-赔款单-添加
    storeReparation() {
      let datas = {
        reparation_sn: this.reparation_sn,
        liable_type: this.liable_type,
        liable_content: '',
        afterSaleDetailSet: [],
        reason: this.reason,
        reparationList: JSON.parse(JSON.stringify(this.reparationList)),
        reparation_num: this.reparation_num,
        reparation_type: this.reparation_type,
        reparation_reason: this.reparation_reason,
        should_amount: this.should_amount,
        actual_amount: this.actual_amount,
        team_amount: this.team_amount,
      }
      // 责任主体内容(责任人ID,物流号,卖家ID)
      if (this.liable_type == 1) {
        datas.liable_content = this.liable_content
      } else if (this.liable_type == 2) {
        datas.liable_content = this.wuliuName
      } else if (this.liable_type == 3) {
        datas.liable_content = this.thirdParty
      }
      //  if (datas.reparation_reason == '') return this.$message.error('赔款类别未选择')
      if (this.reason == '') return this.$message.error('赔款原因未填写')
      // 售后详情id 售后详情赔款比例
      this.indemnityList.forEach(item => {
        item.list.forEach(items => {
          datas.afterSaleDetailSet.push({
            id: items.id,
            rate: items.rate,
          })

        })
      })
      if (!this.validateReparationReason()) return
      this.$api.capitalApi.storeReparation(datas).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$parent.aftersaleDetail()

      })

    },
    //type转换name
    amountRefundName(key) {
      if (this.amountRefundType != false) {
        let item = this.amountRefundType.find((item) => item.key == key);
        return item.value;
      } else {
        return false;
      }
    },
    //售后-赔款单-获取新赔款单号
    getNewReparationSn() {
      this.$api.capitalApi.getNewReparationSn().then(res => {
        this.reparation_sn = res.data
      })
    },
    //新增
    add() {
      this.reparationList.push({
        main: '',
        rate: 1,
        amount: 0,
        type: '2',
        name: '',
        should_amount: 0,
      })
      // console.log(this.adminList);
    },
    // 删除
    del(i) {
      this.reparationList.splice(i, 1)
      this.actual_amount_total()
    },
    //责任人类别:选择
    changeRadio(e) {
      if (e == 1) {
        this.getReparationsByUser()
      } else if (e == 2) {
        this.reparationList = []
        this.reparationList.push({
          main: this.wuliuName,
          rate: 1,
          amount: this.should_amount,
          type: '3',
          name: this.wuliuName,
          should_amount: this.should_amount,
        })
      } else if (e == 3) {
        this.reparationList = []
        this.reparationList.push({
          main: this.thirdParty,
          rate: 1,
          amount: this.should_amount,
          type: '3',
          name: this.thirdParty,
          should_amount: this.should_amount,
        })
      }
      this.actual_amount_total()
      this.$forceUpdate()

    },
    //选择主责任人
    changeAdmin(e) {
      let item = this.adminList.find(item => item.id == e)
      this.liable_organization = item.role[0].organization.name
      this.responsiblePersonData.roleName = item.role[0].name
      this.liable_name = item.realname
      if (this.liable_type == 1) {
        this.responsiblePersonData.main = e
        this.responsiblePersonData.name = this.liable_name
        this.getReparationsByUser()
        this.reparationReason(e)
      }
    },
    // 选择其他责任类别
    otherResponsibility() {
      if (this.liable_type == 2) {
        this.reparationList[0].name = this.wuliuName
        this.reparationList[0].main = this.wuliuName
      } else if (this.liable_type == 3) {
        this.reparationList[0].name = this.thirdParty ? this.thirdParty : '第三方买家'
        this.reparationList[0].main = this.thirdParty ? this.thirdParty : '第三方买家'

      }
    },
    // 关联责任人选择
    changeName(e, i) {
      let role = this.adminList.find(item => item.id == e).role
      if (role != false) {
        this.reparationList[i].name = role[0].name
      } else {
        this.reparationList[i].name = ''
      }
    },
    //计算合计
    actual_amount_total() {
      this.actual_amount = 0
      this.team_amount = 0
      this.reparationList.forEach(item => {
        this.actual_amount += item.amount - 0
        this.team_amount += item.amount - 0
      })
    },
    getShouldAmount() {
      // 有数量和单价时取“数量×单价”和业务赔款总额中的较大值，否则取业务赔款总额。
      let goodsAmount = 0
      let businessAmount = 0
      let hasGoodsPrice = false
      this.indemnityList.forEach(item => {
        item.list.forEach(items => {
          const quantity = Number(items.num)
          const price = Number(items.confirm_price)
          if (items.num !== '' && items.num != null && items.confirm_price !== '' && items.confirm_price != null &&
            Number.isFinite(quantity) && Number.isFinite(price)) {
            hasGoodsPrice = true
            goodsAmount += quantity * price
          }
          const itemTotal = Number(items.amount_goods_amount || 0) + Number(items.amount_freight_amount || 0) +
            Number(items.amount_service_amount || 0) + Number(items.amount_option_amount || 0)
          businessAmount += itemTotal / Number(item.exchange_rate || 1) * Number(items.rate || 0) / 100
        })
      })
      return (hasGoodsPrice ? Math.max(goodsAmount, businessAmount) : businessAmount).toFixed(2)
    },
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        // 获取赔款单号
        this.getNewReparationSn()
        this.reparation_sn = ''//赔款单号
        this.options = []//责任人选择
        this.liable_type = '' //责任人类别
        this.liable_content = ''//责任主体内容
        this.liable_name = '' //责任人名称
        this.liable_organization = '' //责任人所在组织:
        this.wuliuName = '' //物流填写
        this.thirdParty = ''//第三方卖家
        this.reason = '' //赔款原因
        this.actual_amount = 0 //理应赔款
        this.team_amount = 0
        this.teamAmountEdited = false
        this.reparation_num = 0 //赔款数量
        this.reparation_reason = ''//赔款类别
        this.reparationReason()
        this.should_amount = 0 //实际理应赔款
        this.reparation_type = '默认' // 赔款类型
        this.reparationList = [] //关联责任人
        this.responsiblePersonData = {
          type: '1',
          main: '',
          rate: 0,
          amount: 0,
          name: '',
        },
          // 赔款数量
          this.indemnityList.forEach(item => {
            item.list.forEach(items => {
              this.reparation_num += items.num - 0
            })
          })
        this.total = 0 //合计
        this.should_amount = this.getShouldAmount()
        console.log(this.indemnityList);
      }
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-radio__inner {
  transform: scale(1.5) !important;
}

/deep/.el-textarea__inner {
  height: 100px;
}

.head {
  padding: 0 24px;
  height: 56px;
  line-height: 56px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  margin-bottom: 16px;
  display: flex;
  position: relative;
  font-size: 14px;

  .item {
    margin-right: 60px;
  }

  .el-button {
    position: absolute;
    top: 8px;
    right: 24px;
  }
}

.content {
  padding: 16px 24px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;

  .table_detail {
    .detail_head {
      display: flex;
      font-size: 14px;
      height: 60px;
      background: #545467;
      border-radius: 4px;
      color: #fff;
      margin-top: 20px;

      .order {
        display: flex;
        align-items: center;
        padding-left: 16px;
      }

      .item {
        margin-left: 60px;
        line-height: 60px;
      }
    }
  }

  .table {
    font-size: 12px;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;

      li {
        padding: 24px 0;
        position: relative;
      }
    }

    .flex15 {
      flex: 1.5;
    }

    .flex05 {
      flex: 0.5;
    }

    .attribute {
      width: 100%;
      text-align: center;
      max-height: 100px;
      overflow: hidden;

      .el-button {
        position: absolute;
        top: 5px;
        right: 10px;
      }
    }

    .imgList {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .imgs {
        width: 40px;
        height: 40px;
        margin: 0px 0px 10px 10px;

        .el-image {
          width: 40px;
          height: 40px;
          border: 1px dashed #ccc;
          text-align: center;
          line-height: 40px;
          font-size: 20px;
          border-radius: 3px;
          cursor: pointer;
        }
      }
    }

    .radio {
      flex: 9;
      width: 100%;
      justify-content: flex-start;

      span {
        margin: 0 40px 0 13px;
      }
    }
  }

  .add {
    text-align: right;
    margin-top: 20px;
  }

  .indemnity_details {
    display: flex;
    margin-top: 24px;

    .responsible_box {
      .responsible_person {
        border: 2px solid #32323C;

        .row {
          border-bottom: 1px solid #32323C;



          &:nth-last-child(1) {
            border: 0
          }

          display: flex;

          .label {
            width: 150px;
            border-right: 1px solid #32323C;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 14px 0;
          }

          .val {
            flex: 1;
            padding: 14px 30px;

            .item {
              display: flex;
              line-height: 40px;

              .radio {
                width: 120px;
                margin-right: 10px;

              }

              .input {
                width: 180px;

                /deep/.el-select {
                  width: 100%;
                }

                /deep/.el-input {
                  width: 100%;
                }
              }
            }
          }
        }
      }
    }


    .expenses_details {
      width: 1120px;
      margin-left: 50px;

      .total {
        display: flex;
        margin-bottom: 10px;

        .item {
          flex: 1;
          font-size: 16px;
          font-weight: bold;
          display: flex;
          line-height: 40px;

          /deep/.el-input {
            width: 100px;
            margin: 0 10px;
          }
        }
      }

      input {
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        height: 38px;
        width: 70%;
        padding: 0 10px;
      }

      ul {
        li {
          &:nth-child(1) {
            background-color: #fff;
          }
        }
      }
    }
  }

  /deep/.el-input {
    width: 80%;
  }

  /deep/.el-textarea__inner {
    width: 90%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style>
